import { Alert, AlertIcon, Box, Heading, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { isSandboxEnv } from "../../shared/util";

type SandboxUnsupportedRouteProps = {
  children: ReactNode;
};

export default function SandboxUnsupportedRoute({ children }: SandboxUnsupportedRouteProps) {
  if (!isSandboxEnv()) return <>{children}</>;

  return (
    <Box p={8}>
      <Alert status="info" borderRadius="md" alignItems="flex-start">
        <AlertIcon />
        <Box>
          <Heading size="sm" mb={2}>
            EHR integration not supported in sandbox
          </Heading>
          <Text>
            This EHR integration is not available in the sandbox environment. Use the embedded
            dashboard route instead.
          </Text>
        </Box>
      </Alert>
    </Box>
  );
}
